import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Button, Grid, IconButton, ListItemButton, Stack, TextField, Tooltip } from '@mui/material';
import { Add, ArrowBackIos, Delete, Edit, FiberNew, SaveOutlined } from '@mui/icons-material';
import RulesPopover from '../user/RulesPopover';
import Service from '../../../../util/Service';

export default function PapeisPanel(props) {
    const { actionAddPapel } = props;
    const [tela, setTela] = React.useState('escolhe');
    const [nome, setNome] = React.useState('');
    // const [papel, setPapel] = React.useState();
    const [regras, setRegras] = React.useState();
    const [papeis, setPapeis] = React.useState([]);
    const [lst, setLst] = React.useState();

    React.useEffect(() => {
        buscaPapeis();
        buscaTodasRegras();
    }, [])
    const buscaTodasRegras = () => {
        Service.GET("/api/acesso/findAll").then(r => setLst(r));
    }
    const buscaPapeis = () => {
        Service.GET('/api/security/setting/buscaByTipo/papel').then(r => {
            setPapeis(r);
        })
    }
    const handleNovo = () => {
        setTela('novo')
    }
    const handleEditar = (p) => {
        // setPapel(p);
        setNome(p.confs.nome)
        setRegras(p.confs.regras);
        setTela('novo');
    }
    const handleSalvarPapel = () => {
        const dado = {
            nome: nome,
            regras: [],
        }
        if( regras ){
            for (let r of regras) {
                dado.regras.push(r)
            }
        }
        Service.POST('/api/security/setting/incluirPapel', dado).then(r => {
            if (r.success) {
                buscaPapeis();
                setTela("escolhe");
            } else {
                alert(r.msg);
            }
        })
    }
    const handleRemoveRegra = (row) => {
        const arr = [];
        for (let r of regras) {
            if (r === row) continue;
            arr.push(r);
        }
        const dado = {
            nome: nome,
            regras: arr,
        }
        
        Service.POST('/api/security/setting/incluirPapel', dado).then(r => {
            if (r.success) {
                buscaPapeis();
                // setTela("escolhe");
                setRegras(arr);
            } else {
                alert(r.msg);
            }
        })
    }
    function handleRegra(r) {
        const arr = regras ? [...regras] : [];
        arr.push(r.nome);
        setRegras(arr);
    }
    const handleEscolha = (p) => {
        if (actionAddPapel) actionAddPapel(p);
    }
    function telaNovo() {
        if (tela !== 'novo') return;
        return (
            <Grid container spacing={2}>
                <Grid size={12} >
                    <p style={{ fontSize: '12px', color: "darkgray" }}>
                        Se o papel não possuir regra, a regra utilizada será a que o operador tenha em seu cadastro.
                    </p>
                </Grid>
                <Grid size={6}>
                    <div style={{ display: 'flex', padding: '10px' }}>
                        <Tooltip
                            title="Voltar"
                        >
                            <IconButton onClick={() => setTela('escolhe')}
                                color="inherit"
                            >
                                <ArrowBackIos fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <TextField label="Papeis e permissões" variant="outlined"
                            value={nome} onChange={(e) => setNome(e.target.value)}
                        />
                        <Tooltip
                            title="Salvar Papel"
                            className='pd-float-dir'
                        >
                            <IconButton onClick={handleSalvarPapel}
                                color="inherit"
                            >
                                <SaveOutlined />
                            </IconButton>
                        </Tooltip>
                        <RulesPopover currentRoles={regras} action={handleRegra} regras={lst} />
                    </div>
                </Grid>
                <Grid size={6}>
                    <List
                        sx={{
                            width: '100%',
                            maxWidth: 360,
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 300
                        }}
                    >
                        {regras && regras.map((row, id) => {
                            const item = lst.find(l => l.nome === row);
                            if (!item) return (
                                <ListItem key={'rules-' + id}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveRegra(row)}>
                                            <Delete />
                                        </IconButton>
                                    }
                                >
                                    <ListItemText
                                        primary='Não encontrado'
                                    />
                                </ListItem>
                            );
                            return (
                                <ListItem key={'rules-' + id}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveRegra(row)}>
                                            <Delete />
                                        </IconButton>
                                    }
                                >
                                    <ListItemText
                                        primary={item.nome}
                                        secondary={item.descricao}
                                    />
                                </ListItem>
                            )
                        })}

                    </List>
                </Grid>

            </Grid>
        );
    }
    function telaEscolhe() {
        if (tela !== 'escolhe') return;
        return (
            <Stack>
                <div>
                    {/* <Tooltip
                        title="Novo Papel"
                        className='pd-float-dir'
                    >
                        <IconButton
                            size="large"
                            aria-label="novo palel"
                            aria-haspopup="true"
                            onClick={handleNovo}
                            color="inherit"
                        >
                            <FiberNew />
                        </IconButton>
                    </Tooltip> */}
                    <Button className='pd-float-dir' variant="outlined" startIcon={<FiberNew />} onClick={handleNovo}>
                        Novo Papel
                    </Button>
                </div>
                <List sx={{ width: '100%', minWidth: 360, bgcolor: 'background.paper' }}>
                    <ListItem alignItems="flex-start">
                        <ListItemButton onClick={() => handleEscolha('Leitor')}>
                            <ListItemText
                                primary="Leitor"
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{ color: 'text.primary', display: 'inline' }}
                                        >
                                            Observador
                                        </Typography>
                                        {" — Acompanhar as atividades."}
                                    </React.Fragment>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                    {papeis && papeis.map((row, id) => (
                        <React.Fragment key={'lstPapel-' + id}>
                            <Divider variant="inset" component="li" />
                            <ListItem alignItems="flex-start"
                                secondaryAction={
                                    <IconButton edge="end" aria-label="editar" onClick={() => handleEditar(row)}>
                                        <Edit />
                                    </IconButton>
                                }
                            >
                                <ListItemButton onClick={() => handleEscolha(row.confs.nome)}>
                                    <ListItemText
                                        primary={row.confs.nome}
                                    />
                                </ListItemButton>
                            </ListItem>
                        </React.Fragment>
                    ))}

                    <Divider variant="inset" component="li" />
                </List>
            </Stack>
        )
    }

    return (
        <React.Fragment>
            {telaEscolhe()}
            {telaNovo()}
        </React.Fragment>
    )
}